import React from 'react';
import ic_Next from '../../assets/imgs/ic_Next.svg?react';

import './styles.css';
type ButtonNetworkProps = {
    title: string;
    isIcon?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonNetwork: React.FC<ButtonNetworkProps> = React.memo(({ title, isIcon = true, ...rest }) => {
    return (
        <button className="custom-btn-network" {...rest} style={{ width: '100%' }}>
            <p style={{ fontSize: 19, fontWeight: 'bold' }} className="item-btn-title">
                {title}
            </p>
            {isIcon && React.createElement(ic_Next, { className: 'item-ic-icon' })}
        </button>
    );
});

export default ButtonNetwork;
